import { action, createRequestTypes } from '../base';

export const inventoryLocationsTypes = {
  GET_INVENTORY_LOCATIONS: createRequestTypes('GET_INVENTORY_LOCATIONS'),
  CREATE_INVENTORY_LOCATION: createRequestTypes('CREATE_INVENTORY_LOCATION'),
  UPDATE_INVENTORY_LOCATION: createRequestTypes('UPDATE_INVENTORY_LOCATION'),
  DELETE_INVENTORY_LOCATION: createRequestTypes('DELETE_INVENTORY_LOCATION'),
};

/**
 *
 */
class InventoryLocationActions {
    /**
     *
     * @param {*} tenantDepartmentId
     * @param {*} inventoryLocationPath
     * @returns
     */
    getInventoryLocations = (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId, callback) => action(inventoryLocationsTypes.GET_INVENTORY_LOCATIONS.REQUEST, {
      tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId, callback,
    })

    /**
     *
     * @param getInventoryLocationsLoading
     * @return {{type: *}}
     */
    getInventoryLocationsLoading = (getInventoryLocationsLoading) => action(inventoryLocationsTypes.GET_INVENTORY_LOCATIONS.LOADING, {
      getInventoryLocationsLoading,
    })

    /**
     *
     * @param {*} inventoryLocations
     * @returns
     */
    getInventoryLocationsSuccess = (inventoryLocations) => action(inventoryLocationsTypes.GET_INVENTORY_LOCATIONS.SUCCESS, {
      inventoryLocations,
    })

    /**
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    createInventoryLocation = (payload, callback) => action(inventoryLocationsTypes.CREATE_INVENTORY_LOCATION.REQUEST, {
      payload,
      callback,
    })

    /**
     * @param createInventoryLocationLoading
     * @return {{type: *}}
     */
     createInventoryLocationLoading = (createInventoryLocationLoading) => action(inventoryLocationsTypes.CREATE_INVENTORY_LOCATION.LOADING, {
       createInventoryLocationLoading,
     })

    /**
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    updateInventoryLocation = (payload, callback) => action(inventoryLocationsTypes.UPDATE_INVENTORY_LOCATION.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param updateInventoryLocationLoading
     * @return {{type: *}}
     */
    updateInventoryLocationLoading = (updateInventoryLocationLoading) => action(inventoryLocationsTypes.UPDATE_INVENTORY_LOCATION.LOADING, {
      updateInventoryLocationLoading,
    })

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteInventoryLocation = (payload, callback) => action(inventoryLocationsTypes.DELETE_INVENTORY_LOCATION.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param deleteInventoryLocationLoading
   * @return {{type: *}}
   */
   deleteInventoryLocationLoading = (deleteInventoryLocationLoading) => action(inventoryLocationsTypes.DELETE_INVENTORY_LOCATION.LOADING, {
     deleteInventoryLocationLoading,
   })
}

export default new InventoryLocationActions();
